import { render, staticRenderFns } from "./CustomerNotice.vue?vue&type=template&id=2c408dec"
import script from "./CustomerNotice.vue?vue&type=script&lang=js"
export * from "./CustomerNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports